import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import NoIndex from "../NoIndex";

import styles from "./price.module.scss";

function Price({title, priceList, withoutTitle, className}) {
  return (
    <NoIndex>
      <div className={classnames(styles.root, className)}>
        {!withoutTitle && <h2 className={styles.title}>{title}</h2>}
        <div
          className={styles.text}
          dangerouslySetInnerHTML={((__html) => ({__html}))(priceList)}
        />
      </div>
    </NoIndex>
  );
}

Price.propTypes = {
  title: PropTypes.string,
  priceList: PropTypes.string,
  withoutTitle: PropTypes.bool,
  className: PropTypes.string
};

export default Price;
